var definitionListItem = 'fx_e395032e_17s06wu0';

export { definitionListItem };
//# sourceMappingURL=definitionListItem.vanilla.mjs.map
